export class RecordLostObject {
    get id() {
        return this.recordsLostObjectsState.id;
    }
    get inRegister() {
        return this.recordsLostObjectsState.inRegister;
    }
    get inDate() {
        return this.recordsLostObjectsState.inDate;
    }
    get outRegister() {
        return this.recordsLostObjectsState.outRegister;
    }
    get outDate() {
        return this.recordsLostObjectsState.outDate;
    }
    get agentReceptorId() {
        return this.recordsLostObjectsState.agentReceptorId;
    }
    get agentDeliveryId() {
        return this.recordsLostObjectsState.agentDeliveryId;
    }
    get deliveredBy() {
        return this.recordsLostObjectsState.deliveredBy;
    }
    get placeFound() {
        return this.recordsLostObjectsState.placeFound;
    }
    get objType() {
        return this.recordsLostObjectsState.objType;
    }
    get objImage() {
        return this.recordsLostObjectsState.objImage;
    }
    get observations() {
        return this.recordsLostObjectsState.observations;
    }
    get userId() {
        return this.recordsLostObjectsState.userId;
    }
    set id(id) {
        this.recordsLostObjectsState.id = id;
    }
    set inRegister(inRegister) {
        this.recordsLostObjectsState.inRegister = inRegister;
    }
    set inDate(inDate) {
        this.recordsLostObjectsState.inDate = inDate;
    }
    set outRegister(outRegister) {
        this.recordsLostObjectsState.outRegister = outRegister;
    }
    set outDate(outDate) {
        this.recordsLostObjectsState.outDate = outDate;
    }
    set agentReceptorId(agentReceptorId) {
        this.recordsLostObjectsState.agentReceptorId = agentReceptorId;
    }
    set agentDeliveryId(agentDeliveryId) {
        this.recordsLostObjectsState.agentDeliveryId = agentDeliveryId;
    }
    set deliveredBy(deliveredBy) {
        this.recordsLostObjectsState.deliveredBy = deliveredBy;
    }
    set placeFound(placeFound) {
        this.recordsLostObjectsState.placeFound = placeFound;
    }
    set objType(objType) {
        this.recordsLostObjectsState.objType = objType;
    }
    set objImage(objImage) {
        this.recordsLostObjectsState.objImage = objImage;
    }
    set observations(observations) {
        this.recordsLostObjectsState.observations = observations;
    }
    set userId(userId) {
        this.recordsLostObjectsState.userId = userId;
    }
    constructor(recordsLostObjectsState) {
        this.recordsLostObjectsState = recordsLostObjectsState;
    }
    getState() {
        return this.recordsLostObjectsState;
    }
}
